<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import DashboardBase from '../../../dashboard/components/DashboardBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        filterSideBar: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        navItem: {
            label: 'Home',
            icon: 'pi pi-user',
            route: '/(app)/dashboard/',
        },
        navConfig: {
            order: 10,
            navHeader: true,
            leftDrawer: true,
        },
        childNavItems: [
            {
                label: 'Dashboard',
                route: '/(app)/dashboard/',
            },
        ],
    }
})
</script>

<template>
  <DashboardBase />
</template>